module.exports = {"360733100":"文武坝镇","360733101":"筠门岭镇","360733102":"西江镇","360733103":"周田镇","360733104":"麻州镇","360733105":"庄口镇","360733200":"清溪乡","360733201":"右水乡","360733202":"高排乡","360733203":"晓龙乡","360733204":"珠兰乡","360733205":"洞头乡","360733206":"中村乡","360733207":"站塘乡","360733208":"永隆乡","360733209":"富城乡","360733210":"小密乡","360733211":"庄埠乡","360733212":"白鹅乡","360733400":"会昌县燕子窝工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360733.json
// module id = 1300
// module chunks = 0